export type StatsSlotFormat = 'plain' | 'compactK' | 'percent'

export type StatsSlot = {
  target: number
  label: string
  suffix?: string
  format?: StatsSlotFormat
}

export const STAT_CELL_TONES = ['cell0', 'cell1', 'cell2', 'cell3'] as const
export type StatCellTone = (typeof STAT_CELL_TONES)[number]

export function formatSlotValue(slot: StatsSlot, raw: number): string {
  const n = Math.min(Math.max(0, raw), slot.target)

  if (slot.format === 'percent') {
    return `${Math.floor(n)}%`
  }

  if (slot.format === 'compactK') {
    const suf = slot.suffix ?? '+'
    if (n >= 1000) {
      const k = n / 1000
      const s =
        k >= 10 || Number.isInteger(k)
          ? String(Math.round(k))
          : String(Math.round(k * 10) / 10)
      return `${s}K${suf}`
    }
    return `${Math.floor(n)}${suf}`
  }

  return `${Math.floor(n)}${slot.suffix ?? '+'}`
}
